import { SxProps } from "@mui/material";

export const paperStyles: SxProps = {
  p: 0,
  display: "flex",
  flexDirection: "column",
  gap: 2,
  borderRadius: "8px",
  boxShadow: "0 1px 2px 0 rgba(0, 0, 0, 0.05)",
};
export const container = {
  display: "flex",
  flexDirection: "column",
  alignItems: "flex-start",
  gap: "20px",
};
